import { isArsMasterReadDto, TlfArsMasterReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import { VariantInformation } from "functions/tlf/isVariantInformation";
import { TlfContextProps } from "./interface";

interface VariantPatchContext {
  master: TlfContextProps["masterTlfData"];
  currentMaster: TlfArsMasterReadDto | null;
  information: VariantInformation | null;
}

/**
 * Gets the baseline and current patch catalog from TLF reducer state.
 *
 * @param state - Current TLF context state
 * @returns Master snapshot, current master item, and patch information
 */
export const getVariantPatchContext = (
  state: Pick<TlfContextProps, "masterTlfData" | "tlfData">,
): VariantPatchContext => {
  const master = state.masterTlfData;
  const currentMaster = isArsMasterReadDto(state.tlfData) ? state.tlfData : null;
  const information =
    currentMaster === null
      ? null
      : {
          allVariantPatches: currentMaster.allVariantPatches,
          variantTemplates: currentMaster.variantTemplates,
        };
  return {
    master,
    currentMaster,
    information,
  };
};
